<template>
  <section>
    <div class="item">
      <div class="header">
        <span class="header_title">Brochure</span>
        <v-button
          gray
          @click="handleAddFile(1)">Add File</v-button>
      </div>

      <div class="table_group">
        <div class="fileTable table_item">
          <div class="tr bold">
            <div class="td name file_name">Current & Future Files</div>
            <div class="td center">Start Date</div>
            <div class="td operation"></div>
          </div>
          <template v-if="brochure.future_data.length == 0 && brochure.current_data.length == 0">
            <div class="empty tr">No Data</div>
          </template>
          <template v-else>
            <div
              v-for="(f_item, f_i) in brochure.future_data"
              :key="'f'+f_i"
              class="tr">
              <div class="td name">
                <div
                  class="file_name"
                >
                  <p
                    class="pointer"
                    @click="clickFile(f_item.file)">en: {{f_item.file.client_name}}</p>
                  <p
                    class="pointer"
                    @click="clickFile(f_item.ch_file)">zh: {{f_item.ch_file.client_name}}</p>
                </div>
                <span
                  v-if="f_item.stts_language"
                  class="icon green">{{f_item.stts_language}}</span>
              </div>
              <div class="td center">{{f_item.cmnt_date}}</div>
              <div class="td operation">
                <span
                  class="pointer"
                  @click="handleStartNow(f_item)">Start Now</span>
                <span
                  class="pointer"
                  @click="handleEdit(f_item)">Edit</span>
                <span
                  class="del pointer"
                  @click="handleDel(f_item)">Delete</span>
              </div>
            </div>
            <div
              v-for="(c_item, c_i) in brochure.current_data"
              :key="'c'+c_i"
              class="tr blue_bg">
              <div class="td name">
                <div
                  class="file_name"
                >
                  <p
                    class="pointer"
                    @click="clickFile(c_item.file)">en: {{c_item.file.client_name}}</p>
                  <p
                    class="pointer"
                    @click="clickFile(c_item.ch_file)">zh: {{c_item.ch_file.client_name}}</p>
                </div>
                <span
                  v-if="c_item.stts_language"
                  class="icon gray">{{c_item.stts_language}}</span>
              </div>
              <div class="td center">{{c_item.cmnt_date}}</div>
              <div class="td operation"></div>
            </div>
          </template>
        </div>
        <div class="oldFileTable table_item">
          <div class="tr bold">
            <div class="td name">Old Files</div>
            <div class="td center">Start Date</div>
            <div class="td operation"></div>
          </div>
          <template v-if="brochure.old_data.length == 0">
            <div class="empty tr">No Data</div>
          </template>
          <template v-else>
            <div
              v-for="(item, i) in brochure.old_data"
              :key="i"
              class="tr">
              <div class="td name">
                <div
                  class="file_name"
                >
                  <p
                    class="pointer"
                    @click="clickFile(item.file)">en: {{item.file.client_name}}</p>
                  <p
                    class="pointer"
                    @click="clickFile(item.ch_file)">zh: {{item.ch_file.client_name}}</p>
                </div>
                <span
                  v-if="item.stts_language"
                  class="icon green">{{item.stts_language}}</span>
              </div>
              <div class="td center">{{item.cmnt_date}}</div>
              <div class="td operation"></div>
            </div>
          </template>
        </div>
      </div>

      <div class="tips">
        Why can’t I edit old files
        <el-popover
          ref="popover"
          width="230"
          popper-class="popper"
          placement="top-end"
          trigger="hover">
          <p>
            Each policy’s brochure and wordings
            are copied into the policy upon payment.
            To update an old policy’s documents,
            replace them in the policy’s record.
          </p>
          <font-awesome-icon
            slot="reference"
            icon="question-circle"
            class="icon"></font-awesome-icon>
        </el-popover>
      </div>
    </div>

    <div class="line"></div>

    <div class="item">
      <div class="header">
        <span class="header_title">Wording</span>
        <v-button
          gray
          @click="handleAddFile(2)">Add File</v-button>
      </div>

      <div class="table_group">
        <div class="fileTable table_item">
          <div class="tr bold">
            <div class="td name file_name">Current & Future Files</div>
            <div class="td center">Start Date</div>
            <div class="td operation"></div>
          </div>
          <template v-if="wording.future_data.length == 0 && wording.current_data.length == 0">
            <div class="empty tr">No Data</div>
          </template>
          <template v-else>
            <div
              v-for="(f_item, f_i) in wording.future_data"
              :key="'f'+f_i"
              class="tr">
              <div class="td name">
                <div
                  class="file_name"
                >
                  <p
                    class="pointer"
                    @click="clickFile(f_item.file)">en: {{f_item.file.client_name}}</p>
                  <p
                    class="pointer"
                    @click="clickFile(f_item.ch_file)">zh: {{f_item.ch_file.client_name}}</p>
                </div>
                <span
                  v-if="f_item.stts_language"
                  class="icon green">{{f_item.stts_language}}</span>
              </div>
              <div class="td center">{{f_item.cmnt_date}}</div>
              <div class="td operation">
                <span
                  class="pointer"
                  @click="handleStartNow(f_item)">Start Now</span>
                <span
                  class="pointer"
                  @click="handleEdit(f_item)">Edit</span>
                <span
                  class="del pointer"
                  @click="handleDel(f_item)">Delete</span>
              </div>
            </div>
            <div
              v-for="(c_item, c_i) in wording.current_data"
              :key="'c'+c_i"
              class="tr blue_bg">
              <div class="td name">
                <div
                  class="file_name"
                >
                  <p
                    class="pointer"
                    @click="clickFile(c_item.file)">en: {{c_item.file.client_name}}</p>
                  <p
                    class="pointer"
                    @click="clickFile(c_item.ch_file)">zh: {{c_item.ch_file.client_name}}</p>
                </div>
                <span
                  v-if="c_item.stts_language"
                  class="icon gray">{{c_item.stts_language}}</span>
              </div>
              <div class="td center">{{c_item.cmnt_date}}</div>
              <div class="td operation"></div>
            </div>
          </template>
        </div>
        <div class="oldFileTable table_item">
          <div class="tr bold">
            <div class="td name">Old Files</div>
            <div class="td center">Start Date</div>
            <div class="td operation"></div>
          </div>
          <template v-if="wording.old_data.length == 0">
            <div class="empty tr">No Data</div>
          </template>
          <template v-else>
            <div
              v-for="(item, i) in wording.old_data"
              :key="i"
              class="tr">
              <div class="td name">
                <div
                  class="file_name"
                >
                  <p
                    class="pointer"
                    @click="clickFile(item.file)">en: {{item.file.client_name}}</p>
                  <p
                    class="pointer"
                    @click="clickFile(item.ch_file)">zh: {{item.ch_file.client_name}}</p>
                </div>
                <span
                  v-if="item.stts_language"
                  class="icon green">{{item.stts_language}}</span>
              </div>
              <div class="td center">{{item.cmnt_date}}</div>
              <div class="td operation"></div>
            </div>
          </template>
        </div>
      </div>

      <div class="tips">
        Why can’t I edit old files
        <el-popover
          ref="popover"
          width="230"
          popper-class="popper"
          placement="top-end"
          trigger="hover">
          <p>
            Each policy’s brochure and wordings
            are copied into the policy upon payment.
            To update an old policy’s documents,
            replace them in the policy’s record.
          </p>
          <font-awesome-icon
            slot="reference"
            icon="question-circle"
            class="icon"></font-awesome-icon>
        </el-popover>
      </div>
    </div>
    <template v-if="isTravel">
      <div class="line"></div>
      <div class="item">
        <div class="header">
          <span class="header_title">COVID-19 Extension</span>
          <v-button
            gray
            @click="handleAddFile(3)">Add File</v-button>
        </div>

        <div class="table_group">
          <div class="fileTable table_item">
            <div class="tr bold">
              <div class="td name file_name">Current & Future Files</div>
              <div class="td center">Start Date</div>
              <div class="td operation"></div>
            </div>
            <template v-if="covid.future_data.length == 0 && covid.current_data.length == 0">
              <div class="empty tr">No Data</div>
            </template>
            <template v-else>
              <div
                v-for="(f_item, f_i) in covid.future_data"
                :key="'c'+f_i"
                class="tr">
                <div class="td name">
                  <div
                    class="file_name"
                  >
                    <p
                      class="pointer"
                      @click="clickFile(f_item.file)">en: {{f_item.file.client_name}}</p>
                    <p
                      class="pointer"
                      @click="clickFile(f_item.ch_file)">zh: {{f_item.ch_file.client_name}}</p>
                  </div>
                  <span
                    v-if="f_item.stts_language"
                    class="icon green">{{f_item.stts_language}}</span>
                </div>
                <div class="td center">{{f_item.cmnt_date}}</div>
                <div class="td operation">
                  <span
                    class="pointer"
                    @click="handleStartNow(f_item)">Start Now</span>
                  <span
                    class="pointer"
                    @click="handleEdit(f_item)">Edit</span>
                  <span
                    class="del pointer"
                    @click="handleDel(f_item)">Delete</span>
                </div>
              </div>
              <div
                v-for="(c_item, c_i) in covid.current_data"
                :key="'covid'+c_i"
                class="tr blue_bg">
                <div class="td name">
                  <div
                    class="file_name"
                  >
                    <p
                      class="pointer"
                      @click="clickFile(c_item.file)">en: {{c_item.file.client_name}}</p>
                    <p
                      class="pointer"
                      @click="clickFile(c_item.ch_file)">zh: {{c_item.ch_file.client_name}}</p>
                  </div>
                  <span
                    v-if="c_item.stts_language"
                    class="icon gray">{{c_item.stts_language}}</span>
                </div>
                <div class="td center">{{c_item.cmnt_date}}</div>
                <div class="td operation"></div>
              </div>
            </template>
          </div>
          <div class="oldFileTable table_item">
            <div class="tr bold">
              <div class="td name">Old Files</div>
              <div class="td center">Start Date</div>
              <div class="td operation"></div>
            </div>
            <template v-if="covid.old_data.length == 0">
              <div class="empty tr">No Data</div>
            </template>
            <template v-else>
              <div
                v-for="(item, i) in covid.old_data"
                :key="i"
                class="tr">
                <div class="td name">
                  <div
                    class="file_name"
                  >
                    <p
                      class="pointer"
                      @click="clickFile(item.file)">en: {{item.file.client_name}}</p>
                    <p
                      class="pointer"
                      @click="clickFile(item.ch_file)">zh: {{item.ch_file.client_name}}</p>
                  </div>
                  <span
                    v-if="item.stts_language"
                    class="icon green">{{item.stts_language}}</span>
                </div>
                <div class="td center">{{item.cmnt_date}}</div>
                <div class="td operation"></div>
              </div>
            </template>
          </div>
        </div>

        <div class="tips">
          Why can’t I edit old files
          <el-popover
            ref="popover"
            width="230"
            popper-class="popper"
            placement="top-end"
            trigger="hover">
            <p>
              Each policy’s brochure and wordings
              are copied into the policy upon payment.
              To update an old policy’s documents,
              replace them in the policy’s record.
            </p>
            <font-awesome-icon
              slot="reference"
              icon="question-circle"
              class="icon"></font-awesome-icon>
          </el-popover>
        </div>
      </div>
    </template>
    <insurer-file-upload
      ref="fileUpload"
      :form="rowData"
      :type="type"
      @edit="saveEdit"
      @save="handleSave"></insurer-file-upload>
  </section>
</template>

<script>
import {getInsurerPlanDetail, insurerUpoloadFile, insurerEditFile, insurerDelFile} from '@/api/account'
import InsurerFileUpload from './popup/insurerFileUpload.vue'

export default {
  name: 'InsurerPlanDocument',
  components:{
    InsurerFileUpload
  },
  data () {
    return {
      type: 1,
      brochure:{
        current_data: [],
        future_data: [],
        old_data: []
      },
      wording:{
        current_data: [],
        future_data: [],
        old_data: []
      },
      covid:{
        current_data: [],
        future_data: [],
        old_data: []
      },
      rowData:{}
    }
  },
  computed:{
    options(){
      return this.$route.query || null
    },
    isTravel(){
      let {class_id} = this.$route.query
      return class_id == 23
    }
  },
  watch:{
    options:{
      immediate: true,
      deep: true,
      handler(val){
        if(val){
          this.network().getInsurerPlanDetail()
        }
      }
    }
  },
  methods: {
    handleAddFile(type){
      this.type = type
      this.rowData = {}
      this.$refs['fileUpload'].changeDialog()
    },
    handleSave(file){
      Object.keys(this.options).forEach(key => {
        file.append(key, this.options[key])
      })
      file.append('type', this.type)
      this.network().insurerUpoloadFile(file)
    },
    updateDetail(){
      this.network().getInsurerPlanDetail()
    },
    clickFile(file){
      window.open(file.url, '_blank')
    },
    handleStartNow(row){
      let params = {
        id: row.id
      }
      this.network().insurerEditFile(params)
    },
    handleEdit(row){
      // this.rowData= row
      this.$set(this, 'rowData', row)
      console.log(row)
      this.$refs['fileUpload'].changeDialog()
    },
    handleDel(row){
      let params = {
        id: row.id
      }
      this.network().insurerDelFile(params)
    },
    saveEdit(params){
      this.network().insurerEditFile(params)
    },
    network(){
      return {
        getInsurerPlanDetail: async () => {
          const {data} = await getInsurerPlanDetail({
            ...this.options
          })
          this.brochure = data.brochure
          this.wording = data.wording
          let {covid} = data||{}
          if(covid)
            this.covid = covid
        },
        insurerUpoloadFile: async (params) => {
          const {data} = await insurerUpoloadFile(params)
          if(data.id){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.$refs['fileUpload'].changeDialog()
            this.updateDetail()
          }
        },
        insurerEditFile: async (params) => {
          const {data} = await insurerEditFile(params)
          if(data.code == 1000){
            this.$refs['fileUpload'].changeDialog()
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.updateDetail()
          }
        },
        insurerDelFile: async (params) => {
          const {data} = await insurerDelFile(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.updateDetail()
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.item{
  margin-top: 24px;
  .header{
    display: flex;
    justify-content: space-between;
    .header_title{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .table_group{
    margin-top: 20px;
    .table_item{
      .tr{
        background: #FFFFFF;
        border: 1px solid #D1D5DA;
        min-height: 40px;
        display: flex;
        padding: 10px 15px;
        .td{
          flex: 1;
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 14px;
          min-height: 20px;
          color: #24292E;
          &.name{
            min-width: 280px;
            max-width: 400px;
            word-break: break-word;
          }
          &.center{
            flex: 2;
            min-width: 200px;
            justify-content: center;
          }
          &.operation{
            min-width: 200px;
            justify-content: flex-end;
            color: #0366D6;
            .del{
              color: #CB2431;
            }
            span+span{
              margin-left: 15px;
            }
          }
          .file_name{
            font-weight: 600;
            color: #0366D6;
          }
          .icon{
            border-radius: 100px;
            height: 20px;
            padding: 1px 8px;
            margin-left: 15px;
            font-weight: 600;
            text-align: center;
            min-width: 70px;
            &.green{
              border: 1px solid #28A745;
              color: #22863A;
            }
            &.gray{
              border: 1px solid #6A737D;
              color: #24292E;
            }
          }
        }
        &.bold{
          background: #F6F8FA;
          .td{
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #24292E;
          }
        }
        &.empty{
          justify-content: center;
          color: #909399;
          font-size: 14px;
        }
        &.blue_bg{
          background: #F1F8FF;
        }
        &:first-child{
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        &:last-child{
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        &+.tr{
          border-top: 0;
        }
      }
    }
    .oldFileTable{
      margin-top: 30px;
    }
  }
  .tips{
    color: #586069;
    font-weight: 400;
    font-size: 14px;
    margin-top: 20px;
    text-align: right;
    .icon{
      margin-left: 7px;
    }
  }
}
.line{
  border: 1px solid #D1D5DA;
  margin: 30px 0;
}
</style>
<style lang="scss">
.popper{
  background: #24292E;
  border-radius: 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #FFFFFF;
  padding: 0 !important;
  box-sizing: content-box;
  .popper__arrow::after{
    border-top-color: #24292E !important;
  }
  p{
    padding: 6px 8px;
    text-align: center;
    word-break: break-word;
  }
}
</style>
